<div class="froala-container">
  <div
    #editor
    [froalaEditor]="froalaOptions"
    [(froalaModel)]="editorContent"></div>
  <div *ngIf="isSaving" class="spinner-border color-tertiary" role="status">
    <span class="visually-hidden">Saving&hellip;</span>
  </div>
</div>
